import { useState } from "react";
import { AttendingEventType, Place, type AttendingEvent } from "store/attendingEvents/attendingEvents.types";
import AttendEventModal from "views/OrganizationProfile/Events/TabEvents/EventDetail/AttendEventModal";
import EventStatusBadge from "views/OrganizationProfile/Events/TabEvents/EventDetail/EventStatusBadge";
import * as S from "./index.styles";

interface Props {
  attendingEvent: AttendingEvent;
}

const formatPlace = (places: Place[]) => {
  const { place_city, place_state, place_country } = places[0];
  return `${place_city}, ${place_state}, ${place_country}`;
};

const AttendingEventItem: React.FC<Props> = ({ attendingEvent }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const date = new Date(attendingEvent.start_date_time);
  const day = date.getDate();
  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedPlace = formatPlace(attendingEvent.places);

  return (
    <>
      <S.EventCard onClick={() => setIsModalOpen(true)}>
        <S.DateLabel>
          <S.Day>{formattedDay}</S.Day>
          <S.Month>{date.toLocaleString('default', { month: 'short' }).toUpperCase()}</S.Month>
        </S.DateLabel>
        <S.EventInfo>
          <S.EventTitle>{attendingEvent.activity_title}</S.EventTitle>
          {attendingEvent.places !== undefined && <S.EventLocation>{formattedPlace}</S.EventLocation>}
          <EventStatusBadge type={attendingEvent.type} />
        </S.EventInfo>
        {attendingEvent.type !== AttendingEventType.HOST && attendingEvent.type !== AttendingEventType.CONFIRMED && (
          <S.ActionButton>
            {attendingEvent.type === AttendingEventType.TENTATIVE ? "Respond" : "View"}
          </S.ActionButton>
        )}
      </S.EventCard>

      {attendingEvent.type !== AttendingEventType.HOST && attendingEvent.type !== AttendingEventType.CONFIRMED && (
        <AttendEventModal
          event={attendingEvent}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}

export default AttendingEventItem;